import React from 'react'
import LocalAsyncStore from '../../../local-async-store'
import ACCSView from './view'
import RecordMessages from '../../../ui/record-messages'

export const apiEndpointGovEnrolments = ({ child }) => child.accs_path

const ACCSGovEnrolments = (props) => {
  if (!props.child.accs_path) {
    const message = `Cannot create ACCS as ${props.child.first_name} ${props.child.last_name}'s CRN cannot be found. Please ensure CRN is set correctly.`
    return <RecordMessages messages={[{message}]}  />
  }

  const RenderLocalAsyncStore = LocalAsyncStore(
    'accs_gov_enrolments',
    ACCSView,
    apiEndpointGovEnrolments
  )

  return <RenderLocalAsyncStore {...props} />
}

export default ACCSGovEnrolments



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/index.js